/* import __COLOCATED_TEMPLATE__ from './new-session.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { findBy } from 'ilios-common/utils/array-helpers';
import YupValidations from 'ilios-common/classes/yup-validations';
import { string } from 'yup';
let NewSessionComponent = (_class = class NewSessionComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "title", _descriptor2, this);
    _initializerDefineProperty(this, "selectedSessionTypeId", _descriptor3, this);
    _defineProperty(this, "validations", new YupValidations(this, {
      title: string().required().min(3).max(200)
    }));
    _defineProperty(this, "saveNewSession", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.validations.addErrorDisplayForAllFields();
        if (!(yield this.validations.isValid())) {
          return false;
        }
        this.validations.clearErrorDisplay();
        const session = this.store.createRecord('session', {
          title: this.title,
          sessionType: this.selectedSessionType
        });
        yield this.args.save(session);
        this.args.cancel();
      }
    }), null, "saveNewSession", "drop"));
  }
  get activeSessionTypes() {
    return this.args.sessionTypes.filter(sessionType => sessionType.active);
  }
  get selectedSessionType() {
    let selectedSessionType;
    if (this.selectedSessionTypeId) {
      selectedSessionType = this.args.sessionTypes.find(sessionType => {
        return Number(sessionType.id) === this.selectedSessionTypeId;
      });
    }
    if (!selectedSessionType) {
      // try and default to a type names 'Lecture';
      selectedSessionType = findBy(this.args.sessionTypes, 'title', 'Lecture');
    }
    if (!selectedSessionType) {
      selectedSessionType = this.args.sessionTypes[0];
    }
    return selectedSessionType;
  }
  keyboard(event) {
    const keyCode = event.keyCode;
    const target = event.target;
    if ('text' !== target.type) {
      return;
    }
    if (13 === keyCode) {
      this.saveNewSession.perform();
      return;
    }
    if (27 === keyCode) {
      this.cancel();
    }
  }
  changeSelectedSessionTypeId(event) {
    this.selectedSessionTypeId = Number(event.target.value);
  }
  changeTitle(event) {
    this.title = event.target.value;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedSessionTypeId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "keyboard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyboard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeSelectedSessionTypeId", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeSelectedSessionTypeId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeTitle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeTitle"), _class.prototype), _class);
export { NewSessionComponent as default };